import React, { useEffect, useState } from 'react';
import { InputText } from 'primereact/inputtext';
import axios from 'axios';
import Movie from './movie';
import TvShow from './tvShow';
import NetflixSVG from '../../assets/netflix.svg';
import AmazonPrimeSVG from '../../assets/amazon-prime.svg';
import DisneyPlusSVG from '../../assets/disney-plus.svg';
import AppleTVSVG from '../../assets/apple-tv.svg';

const providerSVGs = {
    337: DisneyPlusSVG,
    8: NetflixSVG,
    9: AmazonPrimeSVG,
    350: AppleTVSVG,
};

const SearchContent = ({ searchQuery, setSearchQuery, handleSearch, loading, searchResults }) => {
    const [resultsWithProviders, setResultsWithProviders] = useState([]);

    useEffect(() => {
        const fetchWatchProviders = async () => {
            const updatedResults = await Promise.all(searchResults.map(async (result) => {
                try {
                    const response = await axios.get(`https://api.frazza.online/content/${result.media_type}/${result.id}/watch-providers`);
                    const watchProviders = response.data.results?.US?.flatrate?.map(provider => provider.provider_id) || [];
                    return { ...result, watchProviders };
                } catch (error) {
                    return result;
                }
            }));
            setResultsWithProviders(updatedResults);
        };

        if (searchResults.length > 0) {
            fetchWatchProviders();
        }
    }, [searchResults]);

    return (
        <div className="search-content">
            <h2>Search for Movies & Shows</h2>
            <div className="search-box-movies">
                <i className="pi pi-search search-iconMovies"></i>
                <InputText
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    placeholder="Search for movies or TV shows..."
                    onKeyPress={(e) => e.key === 'Enter' && handleSearch()}
                    className="main-search"
                />
            </div>
            {resultsWithProviders.length > 0 && (
                <div className="search-results">
                    <h3>Search Results</h3>
                    <div className="search-results" style={{
                        display: 'grid',
                        gridTemplateColumns: 'repeat(auto-fill, minmax(180px, 1fr))',
                        gap: '1rem'
                    }}>
                        {resultsWithProviders.map(result => (
                            <div key={result.id} className='search-result-item'>
                                {result.media_type === 'movie' ? (
                                    <Movie
                                        title={result.title}
                                        year={result.release_date}
                                        image={result.poster_path}
                                        rating={result.vote_average}
                                        id={result.id}
                                        isFavorite={result.isFavorite}
                                        isPartnerFavorite={result.isPartnerFavorite}
                                        currentUserId={result.currentUserId}
                                        partnerUserId={result.partnerUserId}
                                        savedBy={result.savedBy}
                                    />
                                ) : (
                                    <TvShow
                                        title={result.name}
                                        year={result.first_air_date}
                                        image={result.poster_path}
                                        rating={result.vote_average}
                                        id={result.id}
                                        isFavorite={result.isFavorite}
                                        isPartnerFavorite={result.isPartnerFavorite}
                                        currentUserId={result.currentUserId}
                                        partnerUserId={result.partnerUserId}
                                        savedBy={result.savedBy}
                                    />
                                )}
                                <div className="provider-icons">
                                    {result.availableOn.map(provider => (
                                        providerSVGs[provider.id] && (
                                            <img key={provider.id} src={providerSVGs[provider.id]} alt={provider.title} />
                                        )
                                    ))}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
};

export default SearchContent;